import React, { useState } from 'react';
import axios from 'axios';
import './DocumentUpload.css';

interface DocumentUploadProps {
  apiUrl: string;
  userToken: string | null;
  onUploadComplete?: () => void;
}

const DocumentUpload: React.FC<DocumentUploadProps> = ({ apiUrl, userToken, onUploadComplete }) => {
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || !userToken) return;

    // Check file type
    const allowedTypes = ['.pdf', '.docx', '.txt', '.py', '.ipynb'];
    const fileExt = '.' + file.name.split('.').pop()?.toLowerCase();
    if (!allowedTypes.includes(fileExt)) {
      setMessage('❌ Only PDF, DOCX, TXT, PY, and IPYNB files allowed');
      return;
    }

    setUploading(true);
    setMessage('📤 Uploading...');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('document_name', file.name);
    formData.append('tags', '');

    try {
      const response = await axios.post(`${apiUrl}/upload-document`, formData, {
        headers: {
          'Authorization': `Bearer ${userToken}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setMessage(`✅ ${response.data.message || 'Document uploaded!'}`);
      if (onUploadComplete) onUploadComplete();

      // Clear message after 3 seconds
      setTimeout(() => setMessage(''), 3000);
    } catch (error: any) {
      console.error('Upload error:', error);
      setMessage(`❌ ${error.response?.data?.detail || 'Upload failed'}`);
    } finally {
      setUploading(false);
      // Reset file input
      e.target.value = '';
    }
  };

  if (!userToken) {
    return (
      <div className="document-upload disabled">
        <p>🔒 Please log in to upload documents</p>
      </div>
    );
  }

  return (
    <div className="document-upload">
      <label htmlFor="doc-upload" className="upload-button">
        {uploading ? '⏳...' : '📄 RAG'}
      </label>
      <input
        id="doc-upload"
        type="file"
        accept=".pdf,.docx,.txt,.py,.ipynb"
        onChange={handleFileUpload}
        disabled={uploading}
        style={{ display: 'none' }}
      />
      {message && <div className="upload-message">{message}</div>}
    </div>
  );
};

export default DocumentUpload;
